import React from "react";
import logo from "../assets/img/connect-facilities-logo-white.png";
export default function MyHeader() {
    // console.log(logo);
    return (
        <div className="header">
            <div className="container">
                <img src={logo} alt="logo" />
            </div>
        </div>
    )
}